import {
  BASE_ARTICLE_45,
  BASE_MANAGEMENT_AGREEMENT,
} from 'src/app/_services/constants/base-contracts-info';
import { ContractToSignInfo } from 'src/app/_services/types/contract-template.types';
import { ContractType } from 'src/app/enums/contract-type.enum';
import { InsuranceTypeEnum } from 'src/app/enums/insurance-type.enum';
import { SelectElement } from 'src/app/ui-kit/components/select/select.component';

import { BUSINESS_INSURANCE_BASE } from '../company-insurance-constants';

export const BUSINESS_HEALTH_INSURANCE_BASE = 'ijm';

export const BUSINESS_HEALTH_FORM_BASE = `${BUSINESS_INSURANCE_BASE}/${BUSINESS_HEALTH_INSURANCE_BASE}`;

export const CONTRACTS_TO_SIGN: ContractToSignInfo[] = [
  {
    ...BASE_ARTICLE_45,
    name: 'Article 45 IJM',
    type: ContractType.ARTICLE_45,
    insuranceType: InsuranceTypeEnum.BUSINESS_HEALTH,
  },
  {
    ...BASE_MANAGEMENT_AGREEMENT,
    name: 'Mandat gestion IJM',
    type: ContractType.MANAGEMENT_AGREEMENT,
    insuranceType: InsuranceTypeEnum.BUSINESS_HEALTH,
  },
];

// Select options for waiting days
export const WAITING_DAYS_OPTIONS: SelectElement<number>[] = [
  { value: 2, label: '2 jours' },
  { value: 14, label: '14 jours' },
  { value: 30, label: '30 jours' },
  { value: 90, label: '90 jours' },
];

// Select options for coverage percent
export const COVERAGE_PERCENT_OPTIONS: SelectElement<number>[] = [
  { value: 80, label: '80%' },
  { value: 90, label: '90%' },
  { value: 100, label: '100%' },
];
